import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="personal-attendances--table-attendance"
export default class extends Controller {
  addRow(event) {
    event.preventDefault()

    const currentRow = event.target.closest(".site-row")
    if (!currentRow) return

    const newRow = currentRow.cloneNode(true)

    this.resetRow(newRow)
    this.element.appendChild(newRow)
  }

  removeRow(event) {
    event.preventDefault()

    const rows = this.element.querySelectorAll(".site-row")
    if (rows.length <= 1) return

    const row = event.target.closest(".site-row")
    if (!row) return

    row.remove()
  }

  resetRow(row) {
    row.querySelectorAll("input, select").forEach(el => {
      if (el.tagName === "SELECT") {
        el.selectedIndex = 0
      } else if (el.type === "checkbox" || el.type === "radio") {
        el.checked = false
      } else {
        el.value = ""
      }
    })
  }
}